module.exports = __webpack_public_path__ + "img/202.fff36ec0.gif";